(() => {
  const selector = '[data-custom-help-widget]';

  const init = (root) => {
    if (!root || root.dataset.customHelpInitialized === 'true') return;
    root.dataset.customHelpInitialized = 'true';

    const toggle = root.querySelector('[data-custom-help-toggle]');
    const panel = root.querySelector('[data-custom-help-panel]');
    const panelClose = root.querySelector('[data-custom-help-close]');
    if (!toggle || !panel) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isThemeEditor = Boolean(window.Shopify && Shopify.designMode);
    const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    const threshold = Math.min(220, Math.max(90, maxScroll * 0.12));
    const visibleDuration = 10000;

    let visible = false;
    let hasAppearedOnce = false;
    let hideTimer;
    let pulseTimer;

    const clearTimers = () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(pulseTimer);
    };

    const scheduleHide = () => {
      window.clearTimeout(hideTimer);
      if (isThemeEditor || root.classList.contains('is-open')) return;
      hideTimer = window.setTimeout(() => {
        visible = false;
        root.classList.remove('chw-is-visible', 'chw-pulse-ready');
      }, visibleDuration);
    };

    const reveal = () => {
      if (visible) return;
      visible = true;
      hasAppearedOnce = true;
      root.classList.add('chw-is-visible');
      window.clearTimeout(pulseTimer);
      pulseTimer = window.setTimeout(() => root.classList.add('chw-pulse-ready'), prefersReducedMotion ? 0 : 650);
      scheduleHide();
    };

    const close = (returnFocus = false) => {
      const wasOpen = root.classList.contains('is-open');
      root.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      if (returnFocus && wasOpen) toggle.focus();
      if (wasOpen && visible) scheduleHide();
    };

    const open = () => {
      clearTimers();
      root.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
    };

    const onScroll = () => {
      if (visible || root.classList.contains('is-open')) return;
      if (!hasAppearedOnce) {
        if (window.scrollY >= threshold) reveal();
        return;
      }
      reveal();
    };

    toggle.addEventListener('click', () => {
      root.classList.contains('is-open') ? close() : open();
    });

    if (panelClose) {
      panelClose.addEventListener('click', () => close(true));
    }

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        close(true);
      }
    });

    root.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => close()));

    root.classList.add('is-scroll-reveal-ready');
    window.addEventListener('scroll', onScroll, { passive: true });

    if (isThemeEditor || prefersReducedMotion || maxScroll <= 0 || window.scrollY >= threshold) {
      requestAnimationFrame(reveal);
    }
  };

  const initAll = (scope = document) => scope.querySelectorAll(selector).forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
